import { Options } from "./options.interfaces";

export class OptionsProvider {
  constructor(private options: Options) {}
}
